import { FundManagerPolicy } from '../../proto/tumelo/stewardshipbff/v1/fund_manager'

export const sampleFundManagerPolicy = (override?: FundManagerPolicy): FundManagerPolicy =>
  FundManagerPolicy.fromPartial({
    id: 'uuid',
    title: 'Voting Policy',
    signedUrl: 'https://www.golang-book.com/public/pdf/gobook.pdf',
    ...override,
  })
